<template>
  <div>
    <span class="sr-only">{{ mloAriaText }}</span>
    <span v-if="isSROnly" class="sr-only">{{ params.valueFormatted }}</span>
    <span v-else>{{ params.valueFormatted }}</span>
  </div>
</template>

<script>
import { getAriaText } from '@utils/helpers';
export default {
  name: 'generic-mlo-cell-renderer',
  data() {
    return {
      mergedCells: ['duration', 'dateTime', 'orderDate'],
      mergedCellsMLO: [
        'duration',
        'dateTime',
        'orderDate',
        'priceInfo',
        'priceType',
        'status',
        'limit',
        'trigger',
        'avgFillPrice'
      ]
    };
  },
  computed: {
    isSROnly() {
      if (this.params.data.index > 0) {
        let mergedCells = this.params.data.strategy === 'MLO' ? this.mergedCellsMLO : this.mergedCells;
        return mergedCells.includes(this.params.colDef.field);
      }
      return false;
    },
    mloAriaText() {
      let mergedCells = this.params.data.strategy === 'MLO' ? this.mergedCellsMLO : this.mergedCells;
      if (mergedCells.includes(this.params.colDef.field)) return this.params.data.allTickerArray.join(', ');
      else return this.getAriaText(this.params);
    }
  },
  methods: {
    getAriaText,
    refresh(params) {
      this.params = params;
      return true;
    }
  }
};
</script>

<style lang="scss" scoped></style>
